import { createFileRoute } from '@tanstack/react-router';
import { useAuth } from '../../../../contexts/AuthContext';
import { Unauthorized } from '../../../../components/Unauthorized';
import { Chart } from '../../../../types/Chart/Chart';
import useChart from '../../../../hooks/useChart';
// import { Header } from '../../../../components/header/Header';
import { PasswordUpdateForm } from '../../../../components/forms/PasswordUpdate';

export const Route = createFileRoute('/_authenticated/$patientId/account/accountInfo')({
  component: AccountInfoPage,
});

function AccountInfoPage() {
  const { patientId } = Route.useParams<{ patientId: string }>();
  const { currentUser } = useAuth();
  const chartQuery = useChart(patientId);
  const data = chartQuery.data as Chart;

  if (chartQuery.isLoading || !data) {
    return <div>Loading patient information...</div>;
  }
  if (!currentUser) {
    return <div>Loading current user</div>;
  }
  if (currentUser?.uid !== patientId) {
    return <Unauthorized />;
  }
  if (currentUser?.uid === patientId && data?.PATIENT_INFO_1) {
    return (
      <>
        {/* <Header patientId={patientId} /> */}
        <div id="account-info-page" className="flex w-screen flex-col items-center justify-center">
          <h1 id="account-info-page-header">Account Information</h1>
          <div id="account-info-page-main" className="flex w-5/6 flex-row justify-around">
            <PasswordUpdateForm />
          </div>
        </div>
      </>
    );
  }

  return <div>Loading...</div>;
}
